import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip } from 'react-tooltip'
import Sidenavbar from '../../Components/Sidenavbar/Sidenavbar';
import UserMenu from '../../Components/UserMenu/UserMenu';
import Paginator from '../../Components/Paginator/Paginator';
import { fetchData } from '../../Services/apiService';


function AdminUsers(props) {
  const userType = 'admin';
  const [show, setShow] = useState(false);
  const [rows, setRows] = React.useState([]);

  const [filteredRows, setFilteredRows] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5); 
  const [totalPages, setTotalPages] = useState(1);

  const onPageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredRows.slice(indexOfFirstItem, indexOfLastItem);

  useEffect(() => {
    const totalItems = filteredRows.length;
    const calculatedTotalPages = totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 1;
    setTotalPages(calculatedTotalPages);
  }, [filteredRows, itemsPerPage]);
  useEffect(() => {
    if (filteredRows.length === 0) {
      setTotalPages(1); 
      setCurrentPage(1); // Asegura que empieces desde la primera página
    }
  }, [filteredRows]);

  useEffect(() => {
    setCurrentPage(1); 
  }, [searchTerm]);

  useEffect(() => {
    const filtered = rows.filter((row) => {
      return row.some((cell) => {
        return cell && String(cell).toLowerCase().includes(searchTerm.toLowerCase());
      });
    });
    setFilteredRows(filtered);
  }, [rows, searchTerm]); 


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleClose = () => setShow(false);
  const transformDataToRows = (data) => {
    if (!data || !data.data) return [];
  
    return data.data.map(item => {
      const row = [
        item.name, 
        item.email,
      ];
      row.push(
        <span className="d-flex">
         
          <a href={`/EditUser/${item.id}`}>
          <button className="-icon mr-16" data-tooltip-id="edit-tooltip" data-tooltip-content="Editar usuario" data-tooltip-place="bottom">
            <i className="fa-solid fa-pencil"></i>
          </button>
          </a>
        </span>
      )
  
    
      return row;
    });
  };
  useEffect(() => {
    

    fetchUserData();
  }, []);
  const fetchUserData = async () => {
    try {
      const data = await fetchData('AppUser');
      const rows = transformDataToRows(data);
    
      setRows(rows); 
    } catch (error) {
      console.error('Error fetching data:', error);
     
    }
  };

  const deleteUser = () => toast.error('Usuario eliminado', {
    position: "top-center",
    autoClose: true,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "dark",
    className: 'Toastify__toast -danger',
  });

  return (
    <div className="container-fluid px-0 m-0 d-flex flex-column flex-md-row">
      <Sidenavbar userType={userType} />
      <div className="container-fluid px-16">
      <UserMenu userType="admin" />
      <ToastContainer />

      {/* Delete user */}
      <Modal
        show={show}
        onHide={() => setShow(false)}
        aria-labelledby="modal-change-request-status"
      >
        <button className="btn -icon button-close" onClick={handleClose}>
          <i class="fa-solid fa-xmark"></i>
        </button>
        <Modal.Header className="justify-content-center">
          <Modal.Title>¿Deseas eliminar a Marco Pérez?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col text-c">
              <p className="body-2">
                Marco Pérez es un administrador, al eliminar el usuario perderá acceso a la plataforma. Esta acción no se puede revertir.
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="row justify-content-end">
            <div className="col-12 col-md-6">
              <button className="btn -secondary" onClick={handleClose}>
                Cancelar
              </button>
            </div>
            <div className="col-12 col-md-6">
              <button className="btn -primary" onClick={deleteUser}>
                Eliminar usuario
              </button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
      {/* Delete user */}

      {/* Upload Error */}
      <Modal
          size="lg"
          show={show}
          onHide={() => setShow(false)}
          aria-labelledby="modal-change-request-status"
        >
          <button className="btn -icon button-close" onClick={handleClose}>
            <i class="fa-solid fa-xmark"></i>
          </button>
          <Modal.Header className="justify-content-center">
            <Modal.Title>Error al subir documento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col">
                <p className="body-2">
                  Hubo un error al subir algunos documentos, regresa y súbelos nuevamente o continua sin agregar.
                </p>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div className="row justify-content-center mt-40">
              <div className="col-12 col-md-6 col-lg-4">
                <button className="btn -secondary" onClick={handleClose}>
                  Regresar
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-4">
                <button className="btn -primary" onClick={handleClose}>
                  Continuar
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      {/* Upload Error */}

        {/* Users */}
        <div className="row mt-40 justify-content-end">
          <div className="col-12 col-lg-4">
            <a href="/CreateUser">
              <button className="btn -primary">
                <i class="fa-solid fa-plus"></i> Agregar usuarios
              </button>
            </a>
          </div>
        </div>
        <div className="row mt-24">
          <div className="col-12">
            <div className="card -raspberry">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      aria-label="Busca por nombre, rol, etc."
                      placeholder="Busca por nombre, rol, etc."
                      onChange={handleSearchChange}

                    />
                    <span class="input-group-text -raspberry">
                      <i class="fa-solid fa-magnifying-glass"></i>
                    </span>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-8 d-flex align-items-center justify-content-end">
                  <p className="body-2 mr-16">Mostrando</p>
                  <span className="counter mr-16">{currentItems.length}</span>
                  <p className="body-2">resultados</p>
                </div>
              </div>
              <div className="row mt-32">
                <div className="col-12">
                  <table className='rounded-corners'>
                    <Tooltip id="edit-tooltip" />
                    <Tooltip id="delete-tooltip" />
                    <thead>
                      <tr>
                        <th className="pl-16">
                          Usuario
                        </th>
                        <th>
                          Correo
                        </th>
                        <th>
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                    {currentItems.map((row, index) => (
                      <tr key={index}>
                        {row.map((cell, cellIndex) => (
                          <td className="pl-16" key={cellIndex}>{cell}</td>
                        ))}
                      </tr>
                    ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="row mt-40">
                <div className="col d-flex justify-content-end">
                <Paginator 
                  currentPage={currentPage} 
                  totalPages={totalPages} 
                  onPageChange={onPageChange} 
                />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Users */}
      </div>
    </div>
  );
}

export default AdminUsers;